import styles from "../aic.module.css";
import { classMerge } from "../utility/classMerge";
import { useBlockContext } from "./BlockContentProvider";
import { UPDATE_BLOCK_CELL } from "./blockReducer";

interface OriginalTextEditorProps {
  aifid: string;
  position: "left" | "center" | "right";
}

/**
 * Editor wrapper for the original text (before replacements) cell in a line
 *
 * @param props - Destructured parameter object
 * @param props.aifid - The block instance id (`aifid`) identifying which line's cell to edit.
 * @param props.position - Cell position in the line: `"left"`, `"center"`, or `"right"`.
 */
export const OriginalTextEditor = ({
  aifid,
  position,
}: OriginalTextEditorProps): React.ReactElement => {
  const { state, dispatch } = useBlockContext();
  const ix = state.lines.findIndex((l) => l.aifid === aifid);
  const thisLine = state.lines[ix];
  const thisCell = thisLine[position];
  const Editor = state.editorProps.Editor;

  const id = `${state.id}-${ix}-${position}-original-text`;
  const label = position.slice(0, 1).toUpperCase() + position.slice(1) + " text";

  return (
    <div className={styles.aiwBodyRow}>
      <label
        className={styles.aioLabel}
        htmlFor={id}
      >
        {label}
      </label>
      <div className={classMerge([styles.aioInputHolder, styles.borderBlackSolid])}>
        <Editor
          id={id}
          value={thisCell}
          editable={!state.disabled && thisLine?.canEdit}
          allowWindowView={false}
          allowMarkdown={false}
          setValue={(ret) =>
            dispatch({
              operation: UPDATE_BLOCK_CELL,
              aifid,
              position,
              cellContent: ret,
            })
          }
        />
      </div>
    </div>
  );
};

OriginalTextEditor.displayName = "OriginalTextEditor";
